import { Component, OnInit } from '@angular/core';
import { CustomService } from '../../_service/custom.service';
import { environment } from '../../../environments/environment';
import { ActivatedRoute,Router } from '@angular/router';

@Component({
    selector: 'app-blog-detail',
    templateUrl: './blog-detail.component.html',
    styleUrls: ['./blog-detail.component.css']
})
export class BlogDetailComponent implements OnInit {

    env : any;
    available_blog_detail : boolean = false;
    blog_detial : any;
    slug :any;
    blog_id : any;
    blog_images : any = [];
    constructor(
        public route:ActivatedRoute,
        public api : CustomService
    ) {
        this.env = environment;

        this.route.params.subscribe(
            (data:any)=>{
                this.slug = data.slug;
                this.blog_id = data.id;
                this.getblogdetail(this.blog_id);
            }
        )

    }

    ngOnInit() {


    }

    getblogdetail(blog_id){
        this.api.blogdetail(blog_id).subscribe(
            (data:any)=>{
                if(data.blogdetail.results.length > 0){
                    this.blog_detial = data.blogdetail.results[0];
                    this.blog_images = data.blogdetail.blogimages;
                    this.available_blog_detail = true;
                }
                console.log(this.blog_detial);
            },(errors:any)=>{
                console.log(errors.error);
            }
        );
    }

}
